import api from '../api/suggest';
var $$match = require('assets/util/match.js');
var assert = require('assets/util/assert.js');

/**
 * 所有callbackFn都是获得数据之后的回调，参数为数据
 */
var vendor = {
    getLoupanFilterData: function (cityId, callbackFn) {
        assert(cityId, 'n:s');

        proxy('loupan-filters', cityId, function (res) {
            if (typeof callbackFn === 'function') {
                callbackFn(res);
            }
        });
    },
    getCityAll: function (callbackFn) {
        proxy('city-all', null, function (res) {
            if (typeof callbackFn === 'function') {
                callbackFn(res);
            }
        });
    },
    getLoupanSuggestions: (cityId, keyword, callbackFn, suggestDomain) => {
        assert(cityId, 's:n');
        assert(keyword, 's');

        var data = {
            cityId: cityId,
            keyword: keyword
        };
        api.getLoupanSuggestions(data).then(bdata => {
            var data;
            if (bdata && bdata.data &&
                bdata.data.searchSuggest &&
                bdata.data.searchSuggest.list &&
                bdata.data.searchSuggest.list.length) {
                data = $$match(bdata, {
                    code: '200',
                    msg: '',
                    data: {
                        list: ['${data.searchSuggest.list}', {
                            'city_id': '${cityId}',
                            "district": "${district}",
                            "pinyin": "${pinyin}",
                            "proj_id": '${projId}',
                            "proj_name": "${projName}",
                            "sale_status": '${saleStatus}',
                            "show_city_id": '${showCityId}',
                            "origin_city_id": '${originCityId}',
                            "str": '${str}',
                            "type": '${type}'
                        } ]
                    }
                });
            } else {
                data = {
                    code: '200',
                    msg: '',
                    data: {
                        list: []
                    }
                }
            }
            callbackFn(data)
        }, res => callbackFn(res))
    },
    getRentSuggestions: (cityId, keyword, callbackFn) => {
        var data = {
            ecoCityId: cityId,
            query: keyword,
            isPC: 1
        };
        api.getRentSuggestions(data).then(bdata => {
            var data;
            if (bdata.data && bdata.data.suggestData && 
                bdata.data.suggestData.length) {
                data = $$match(bdata, {
                    code: '200',
                    msg: '',
                    data: {
                        list: ['${data.suggestData}', {
                            "name": "${name}",
                            "str": '${sub_title}',
                            "url": '${url}'
                        }]
                    }
                });
            } else {
                data = {
                    code: '200',
                    msg: '',
                    data: {
                        list: []
                    }
                }
            }
            callbackFn(data);
        }, res => callbackFn(res))
    },
    getEsfSuggestions: (cityId, keyword, callbackFn) => {
        var data = {
            ecoCityId: cityId,
            query: keyword,
            isPC: 1
        };
        api.getEsfSuggestions(data).then(bdata => {
            var data;
            if (bdata.data && bdata.data.suggestData && 
                bdata.data.suggestData.length) {
                data = $$match(bdata, {
                    code: '200',
                    msg: '',
                    data: {
                        list: ['${data.suggestData}',{
                            "name": "${name}",
                            "str": '${sub_title}',
                            "url": '${url}'
                        }]
                    }
                });
            } else {
                data = {
                    code: '200',
                    msg: '',
                    data: {
                        list: []
                    }
                }
            }
            callbackFn(data);
        }, res => callbackFn(res))
    },
    getMsgAuthCode: function (data, callbackFn) {
        assert(data, {
            phone: 's'
        });

        var parseData = {
            mobile: data.phone,
            imgkey: data.secKey,
            imgcode: data.imgCode,
            type: '2',
            channel: '12'
        };
        api.getMsgAuthCode(parseData).then(bdata => {
            callbackFn(bdata);
        }, res => callbackFn(res))
    },
    getTxAuthCode: function (data, callbackFn) {
        assert(data, {
            phone: 's'
        });
        var parseData = {
            mobile: data.phone,
            randstr: data.randstr,
            ticket: data.ticket,
            type: '2',
            channel: '12'
        };
        api.getTxAuthCode(parseData).then(bdata => {
            callbackFn(bdata);
        }, res => callbackFn(res))
        
    }
};

var cacheConf = [ 'getCityAll' ];

var _cache = {};
var _vendorDo = function (method, args) {
    method.apply(vendor, args);
};
var _innerDecor = function (methodName, argsKey, callback) {
    return function (data) {
        _cache[ methodName ][ argsKey ] = data;
        callback(data);
    };
};
var outerDecor = function (fnName, fn) {
    return function () {
        var args = Array.prototype.slice.call(arguments, 0);
        var key = JSON.stringify(args);
        if (!_cache[ fnName ]) {
            _cache[ fnName ] = {};
        }
        var cacheData = _cache[ fnName ][ key ];
        var callbackFn;
        var j, argLen;
        for (j = 0, argLen = args.length; j < argLen; j++) {
            if (typeof args[ j ] !== 'function') {
                continue;
            }
            callbackFn = args[ j ];
            args[ j ] = _innerDecor(fnName, key, callbackFn);
        }

        if (cacheData) { // cacheData exist
            if (typeof callbackFn === 'function') {
                return callbackFn(cacheData);
            } else {
                return cacheData;
            }
        } else { // cacheData don't exist
            _vendorDo(fn, args);
        }
    };
};

var i, len;
for (i = 0, len = cacheConf.length; i < len; i++) {
    var _fnName = cacheConf[ i ];
    var _fn = vendor[ _fnName ];
    vendor[ _fnName ] = outerDecor(_fnName, _fn);
}

module.exports = vendor;



// WEBPACK FOOTER //
// ./src/model/service/vendor.js